import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

// Tippy.js tooltip on the host element (reads data-tippy-content).
export default class extends Controller {
  connect() {
    this.instance = tippy(this.element, {
      offset: "0, 2",
      animation: "fade",
      arrow: true,
      delay: [0, 0],
      touch: false,
    })
  }

  disconnect() {
    this.instance?.destroy()
    this.instance = null
  }
}
